export default __webpack_public_path__ + "static/media/visualcue.f30cb8d0.png";